import React from 'react';

import { RenderVariant } from '../../../../types';
import { ConfigFieldDropdown, type FieldOption } from '../config-field-dropdown';
import { messages } from './messages';

const manualOption = {
	label: messages.manualRenderVariantDropdownOptionLabel,
	value: RenderVariant.MANUAL,
};
const dynamicOption = {
	label: messages.dynamicRenderVariantDropdownOptionLabel,
	value: RenderVariant.DYNAMIC,
};

const renderVariantOptions: FieldOption<RenderVariant>[] = [manualOption, dynamicOption];

type RenderVariantSwitcherDropdownProps = {
	onUpdate: (newValue: RenderVariant) => void;
	renderVariant: RenderVariant;
	source: string;
};

export const RenderVariantSwitcherDropdown = ({
	renderVariant,
	onUpdate,
	source,
}: RenderVariantSwitcherDropdownProps): React.JSX.Element => (
	<ConfigFieldDropdown<RenderVariant>
		fieldType="render-variant"
		label={messages.dropdownLabel}
		onSelect={(selectedOption) => onUpdate(selectedOption.value)}
		options={renderVariantOptions}
		selectedOption={
			renderVariantOptions.find((option) => option.value === renderVariant) || manualOption
		}
		renderVariant={renderVariant}
		source={source}
		showUpdatedStyles
	/>
);
